/* TRADUCCIONES */
export function initialDetailLiterals(t: any) {
  return {
    reservationdate:t("literals.reservationdate"),
    title: t("initialDetailLiterals.title"),
    subTitle: t("initialDetailLiterals.subTitle"),
    showLess: t("initialDetailLiterals.showLess"),
    showMore: t("initialDetailLiterals.showMore"),
    button: t("initialDetailLiterals.button"),
    choice: [
      {
        code: t("initialDetailLiterals.choice.0.code"),
        text: t("initialDetailLiterals.choice.0.text"),
      },
    ],
    cancelTripModal: {
      title: t("initialDetailLiterals.cancelTripModal.title"),
      description: t("initialDetailLiterals.cancelTripModal.description"),
      buttons: [
        {
          size: t("initialDetailLiterals.cancelTripModal.buttons.0.size"),
          styleButton: t(
            "initialDetailLiterals.cancelTripModal.buttons.0.styleButton"
          ),
          idButton: t(
            "initialDetailLiterals.cancelTripModal.buttons.0.idButton"
          ),
          type: t("initialDetailLiterals.cancelTripModal.buttons.0.type"),
          text: t("initialDetailLiterals.cancelTripModal.buttons.0.text"),
        },
        {
          size: t("initialDetailLiterals.cancelTripModal.buttons.1.size"),
          styleButton: t(
            "initialDetailLiterals.cancelTripModal.buttons.1.styleButton"
          ),
          idButton: t(
            "initialDetailLiterals.cancelTripModal.buttons.1.idButton"
          ),
          type: t("initialDetailLiterals.cancelTripModal.buttons.1.type"),
          text: t("initialDetailLiterals.cancelTripModal.buttons.1.text"),
        },
      ],
    },
    headerButton: {
      id: t("initialDetailLiterals.cancelTripModal.headerButton.id"),
      text: t("initialDetailLiterals.cancelTripModal.headerButton.text"),
      type: t("initialDetailLiterals.cancelTripModal.headerButton.type"),
      el: t("initialDetailLiterals.cancelTripModal.headerButton.el"),
    },

    // TODO: cambiar literales
    cancelPstAveModal: {
      title: t("initialDetailLiterals.cancelPstAveModal.title"),
      desc: t("initialDetailLiterals.cancelPstAveModal.desc"),
      okbutton: t("initialDetailLiterals.cancelPstAveModal.okbutton"),
      cancelbutton: t("initialDetailLiterals.cancelPstAveModal.cancelbutton"),
    },
    cancelPstAskAveModal: {
      title: t("initialDetailLiterals.cancelPstAskAveModal.title"),
      description: t("initialDetailLiterals.cancelPstAskAveModal.description"),
      buttons: [
        {
          size: "w100",
          styleButton: "outline",
          idButton: "cancel-button",
          type: "button",
          text: t("initialDetailLiterals.cancelPstAskAveModal.buttons.0.text"),
        },
        {
          size: "w100",
          styleButton: "primary",
          idButton: "continue-button",
          type: "button",
          text: t("initialDetailLiterals.cancelPstAskAveModal.buttons.1.text"),
        },
      ],
      toast: {
        textTitle: t(
          "initialDetailLiterals.cancelPstAskAveModal.toast.textTitle"
        ),
        textDesc: t(
          "initialDetailLiterals.cancelPstAskAveModal.toast.textDesc"
        ),
      },
    },
    cancelPstAskModal: {
      title: t("initialDetailLiterals.cancelPstAskModal.title"),
      description: t("initialDetailLiterals.cancelPstAskModal.description"),
      buttons: [
        {
          size: "w100",
          styleButton: "outline",
          idButton: "cancel-button",
          type: "button",
          text: t("initialDetailLiterals.cancelPstAskModal.buttons.0.text"),
        },
        {
          size: "w100",
          styleButton: "primary",
          idButton: "continue-button",
          type: "button",
          text: t("initialDetailLiterals.cancelPstAskModal.buttons.1.text"),
        },
      ],
    },
    cancelPstTaxiVtcAskModal: {
      title: t("initialDetailLiterals.cancelPstTaxiVtcAskModal.title"),
      description: t(
        "initialDetailLiterals.cancelPstTaxiVtcAskModal.description"
      ),
      buttons: [
        {
          size: "w100",
          styleButton: "outline",
          idButton: "cancel-button",
          type: "button",
          text: t(
            "initialDetailLiterals.cancelPstTaxiVtcAskModal.buttons.0.text"
          ),
        },
        {
          size: "w100",
          styleButton: "primary",
          idButton: "continue-button",
          type: "button",
          text: t(
            "initialDetailLiterals.cancelPstTaxiVtcAskModal.buttons.1.text"
          ),
        },
      ],
    },
    errorCancelation: {
      title: t("initialDetailLiterals.errorCancelation.title"),
      description: t("initialDetailLiterals.errorCancelation.description"),
      buttons: [
        {
          size: "w100",
          styleButton: "primary",
          idButton: "continue-button",
          type: "button",
          text: t("initialDetailLiterals.errorCancelation.buttons.0.text"),
        },
      ],
    },
    alreadyCancelled: {
      title: t("initialDetailLiterals.alreadyCancelled.title"),
      description: t("initialDetailLiterals.alreadyCancelled.description"),
      buttons: [
        {
          size: "w100",
          styleButton: "primary",
          idButton: "continue-button",
          type: "button",
          text: t("initialDetailLiterals.alreadyCancelled.buttons.0.text"),
        },
      ],
    },
    cancelPstBoltAskModal: {
      title: t("initialDetailLiterals.cancelPstBoltAskModal.title"),
      description: t("initialDetailLiterals.cancelPstBoltAskModal.description"),
      descBold: t("initialDetailLiterals.cancelPstBoltAskModal.descBold"),
      buttons: [
        {
          size: "w100",
          styleButton: "outline",
          idButton: "cancel-button",
          type: "button",
          text: t("initialDetailLiterals.cancelPstBoltAskModal.buttons.0.text"),
        },
        {
          size: "w100",
          styleButton: "primary",
          idButton: "continue-button",
          type: "button",
          text: t("initialDetailLiterals.cancelPstBoltAskModal.buttons.1.text"),
        },
      ],
    },
    disclaimer:{
      title:t("initialDetailLiterals.disclaimer.title"),
      clientService:t("initialDetailLiterals.disclaimer.clientService"),
      url:t("initialDetailLiterals.disclaimer.url"),
    },
    errorCancelledKid: {
      title: t("initialDetailLiterals.errorCancelledKid.title"),
      description: t("initialDetailLiterals.errorCancelledKid.description"),
      buttons: [
        {
          size: "w100",
          styleButton: "primary",
          idButton: "continue-button",
          type: "button",
          text: t("initialDetailLiterals.errorCancelledKid.buttons.0.text"),
        },
      ],
    },
    tripNotPay: {
      title: t("initialDetailLiterals.tripNotPay.title"),
      description: t("initialDetailLiterals.tripNotPay.description"),
    }
  };
}

export function initialDetailLiteralsAtom(t: any) {
  return {
    eachTime: t("initialDetailLiteralsAtom.eachTime"),
    // action: 'En la estación, coge el tren', // ¿Dinámico desde el servicio?
    delete: t("initialDetailLiteralsAtom.delete"),
    canceled: t("initialDetailLiteralsAtom.canceled"),
    walkTransbordo: t("initialDetailLiteralsAtom.walkTransbordo"),
    walkDestination: t("initialDetailLiteralsAtom.walkDestination"),

    /* UI-ROUTE-START-END LITERALS */
    leaveFrom: t("initialDetailLiteralsAtom.leaveFrom"),
    arrivedAt: t("initialDetailLiteralsAtom.arrivedAt"),
    /* FIN  UI-ROUTE-START-END LITERALS */

    /* UI-STOPS LITERALS*/
    seeRoute: t("initialDetailLiteralsAtom.seeRoute"),
    step: t("initialDetailLiteralsAtom.step"),
    steps: t("initialDetailLiteralsAtom.steps"),
    direct: t("initialDetailLiteralsAtom.direct"),
    durationEstimated: t("initialDetailLiteralsAtom.durationEstimated"),
    actionStart: t("initialDetailLiteralsAtom.actionStart"),
    actionEnd: t("initialDetailLiteralsAtom.actionEnd"),
    altFoldIcon: t("initialDetailLiteralsAtom.altFoldIcon"),
    altUnfoldIcon: t("initialDetailLiteralsAtom.altUnfoldIcon"),
    drivingLicense: t("initialDetailLiteralsAtom.drivingLicense"),
    tripId: t("initialDetailLiteralsAtom.tripId"),
    walkCheckIn: t("initialDetailLiteralsAtom.walkCheckIn"),
    toltip: t("initialDetailLiteralsAtom.toltip"),
    openRealTime:t("initialDetailLiteralsAtom.openRealTime"),
    thereAreWarnings:t("initialDetailLiteralsAtom.thereAreWarnings"),
    moreInformation:t("initialDetailLiteralsAtom.moreInformation"),

    paymentXpay:t("initialDetailLiteralsAtom.paymentXpay"),
    comment:t("initialDetailLiteralsAtom.comment"),
    /* FIN UI-STOPS LITERALS */
    /* Trip State Literals */
  };
}
export function initialTicketsModalLiterals(t: any) {
  return {
    literals: {
      ticketLiterals: {
        cancelation: t(
          "initialTicketsModalLiterals.literals.ticketLiterals.cancelation"
        ),
        reminder: t(
          "initialTicketsModalLiterals.literals.ticketLiterals.reminder"
        ),
        title: t("initialTicketsModalLiterals.literals.ticketLiterals.title"),
        desc1: t("initialTicketsModalLiterals.literals.ticketLiterals.desc1"),
        desc2: t("initialTicketsModalLiterals.literals.ticketLiterals.desc2"),
        desc3: t("initialTicketsModalLiterals.literals.ticketLiterals.desc3"),
        desc4: t("initialTicketsModalLiterals.literals.ticketLiterals.desc4"),
        desc5: t("initialTicketsModalLiterals.literals.ticketLiterals.desc5"),
        item1: t("initialTicketsModalLiterals.literals.ticketLiterals.item1"),
        item2: t("initialTicketsModalLiterals.literals.ticketLiterals.item2"),
        item3: t("initialTicketsModalLiterals.literals.ticketLiterals.item3"),
        conditionButton: t(
          "initialTicketsModalLiterals.literals.ticketLiterals.conditionButton"
        ),
        qrcanceltitle: t(
          "initialTicketsModalLiterals.literals.ticketLiterals.qrcanceltitle"
        ),
        qrcanceldesc: t(
          "initialTicketsModalLiterals.literals.ticketLiterals.qrcanceldesc"
        ),
      },
      modalLiterals: {
        title: t("initialTicketsModalLiterals.literals.modalLiterals.title"),
        cancelButton: t(
          "initialTicketsModalLiterals.literals.modalLiterals.cancelButton"
        ),
        downloadButton: t(
          "initialTicketsModalLiterals.literals.modalLiterals.downloadButton"
        ),
      },
    },
  };
}
export function initialAveTicketsLiterals(t: any) {
  return {
    literals: {
      title: t("initialAveTicketsLiterals.literals.title"),
      desc: t("initialAveTicketsLiterals.literals.desc"),
      okbutton: t("initialAveTicketsLiterals.literals.okbutton"),
      cancelbutton: t("initialAveTicketsLiterals.literals.cancelbutton"),
    },
    passengers: [
      {
        id: t("initialAveTicketsLiterals.passengers.0.id"),
        fullname: t("initialAveTicketsLiterals.passengers.0.fullname"),
        ticketId: t("initialAveTicketsLiterals.passengers.0.ticketId"),
      },
    ],
  };
}
export function desgloseModalLiterals(t: any) {
  return {
    title: t("desgloseModalLiterals.title"),
    altCloseModal: t("desgloseModalLiterals.altCloseModal"),
    departureJourney: t("desgloseModalLiterals.departureJourney"),
    arrivalJourney: t("desgloseModalLiterals.arrivalJourney"),
    externalBuy: t("desgloseModalLiterals.externalBuy"),
    altExternalBuy: t("desgloseModalLiterals.altExternalBuy"),
    tooltipText: t("desgloseModalLiterals.tooltipText"),
    payNow: t("desgloseModalLiterals.payNow"),
    payLater: t("desgloseModalLiterals.payLater"),
    payTotal: t("desgloseModalLiterals.payTotal"),
    canceled: t("desgloseModalLiterals.canceled"),
    reserved: t("desgloseModalLiterals.reserved"),
    noReserved: t("desgloseModalLiterals.noReserved"),
    payDeparture: t("desgloseModalLiterals.payDeparture"),
    payReturn: t("desgloseModalLiterals.payReturn"),
    onlyOutwardTrip: t("desgloseModalLiterals.onlyOutwardTrip"),
    totalamount: t("desgloseModalLiterals.totalamount"),
    waiting: t("desgloseModalLiterals.waiting"),
    discount: t("desgloseModalLiterals.discount"),
    stocked: t("desgloseModalLiterals.stocked"),
    discountsUNKNOWN: t("desgloseModalLiterals.discountsUNKNOWN"),
    provisionedTooltip: t("desgloseModalLiterals.provisionedTooltip"),
  };
}
export function getInitialCancelModalLiterals(t: any) {
  return {
    title: t("getInitialCancelModalLiterals.title"),
    desc: t("getInitialCancelModalLiterals.desc"),
    cancelbutton: t("getInitialCancelModalLiterals.cancelbutton"),
    okbutton: t("getInitialCancelModalLiterals.okbutton"),
  };
}
export function NoTripsPageLiterals(t: any) {
  return {
    titlePage: t("NoTripsPageLiterals.titlePage"),
    title: t("NoTripsPageLiterals.title"),
    description: t("NoTripsPageLiterals.description"),
    description2: t("NoTripsPageLiterals.description2"),
    leftButton: {
      type: t("NoTripsPageLiterals.leftButton.type"),
      text: t("NoTripsPageLiterals.leftButton.text"),
      id: t("NoTripsPageLiterals.leftButton.id"),
    },
    imageSection: {
      name: t("NoTripsPageLiterals.imageSection.name"),
      alt: t("NoTripsPageLiterals.imageSection.alt"),
    },
  };
}
export function CallFailedPageLiterals(t: any) {
  return {
    titlePage: t("CallFailedPageLiterals.titlePage"),
    title: t("CallFailedPageLiterals.title"),
    description: t("CallFailedPageLiterals.description"),
    leftButton: {
      type: t("CallFailedPageLiterals.leftButton.type"),
      text: t("CallFailedPageLiterals.leftButton.text"),
      id: t("CallFailedPageLiterals.leftButton.id"),
    },
    imageSection: {
      name: t("CallFailedPageLiterals.imageSection.name"),
      alt: t("CallFailedPageLiterals.imageSection.alt"),
    },
  };
}
export function NoSessionPageLiterals(t: any) {
  return {
    titlePage: t("NoSessionPageLiterals.titlePage"),
    title: t("NoSessionPageLiterals.title"),
    description: t("NoSessionPageLiterals.description"),
    leftButton: {
      type: t("NoSessionPageLiterals.leftButton.type"),
      text: t("NoSessionPageLiterals.leftButton.text"),
      id: t("NoSessionPageLiterals.leftButton.id"),
    },
    rightButton: {
      type: t("NoSessionPageLiterals.rigthButton.type"),
      text: t("NoSessionPageLiterals.rigthButton.text"),
      id: t("NoSessionPageLiterals.rigthButton.id"),
    },
    imageSection: {
      name: t("NoSessionPageLiterals.imageSection.name"),
      alt: t("NoSessionPageLiterals.imageSection.alt"),
    },
  };
}
export function getFooterLiterals(t: any) {
  return {
    title: t("footer.title"),
    showPrivacyPolicyText: t("footer.showPrivacyPolicyText"),
    showLegalConditionsText: t("footer.showLegalConditionsText"),
    showCookiePolicyText: t("footer.showCookiePolicyText"),
    linkPrivacyPolicyText: "https://www.docomobility.com/es/privacidad",
    linkLegalConditionsText:
      "https://www.docomobility.com/es/terminos-y-condiciones",
    linkCookiePolicyText: "https://www.docomobility.com/es/politica-de-cookies",
  };
}
export function tmbValidatorTicketLiterals(t: any) {
  return {
    head: t("tmbValidatorTicketLiterals.head"),
    preTitle: t("tmbValidatorTicketLiterals.preTitle"),
    title: t("tmbValidatorTicketLiterals.title"),
    descTravelCard: [
      {
        text: t("tmbValidatorTicketLiterals.descTravelCardFirst"),
        bold: false,
      },
      {
        text: t("tmbValidatorTicketLiterals.descTravelCardSecond"),
        bold: true,
      },
      {
        text: t("tmbValidatorTicketLiterals.descTravelCardThird"),
        bold: false,
      },
    ],
    desc: t("tmbValidatorTicketLiterals.desc"),
    valid: t("tmbValidatorTicketLiterals.valid"),
    impresion: t("tmbValidatorTicketLiterals.impresion"),
    emision: t("tmbValidatorTicketLiterals.emision"),
    cancelButton: t("tmbValidatorTicketLiterals.cancelButton"),
    useButton: t("tmbValidatorTicketLiterals.useButton"),
  };
}
export function tmbCancelTicketLiterals(t: any) {
  return {
    title: t("tmbCancelTicketLiterals.title"),
    desc: t("tmbCancelTicketLiterals.desc"),
    okButton: t("tmbCancelTicketLiterals.okButton"),
  };
}
export function tmbCancelErrorLiterals(t: any) {
  return {
    title: t("tmbCancelErrorLiterals.title"),
    desc: t("tmbCancelErrorLiterals.desc"),
    okButton: t("tmbCancelErrorLiterals.okButton"),
  };
}

export function tmbUsedConfirmActivityModal(t: any) {
  return {
    title: t("tmbUsedConfirmActivityModal.title"),
    desc: t("tmbUsedConfirmActivityModal.desc"),
    okButton: t("tmbUsedConfirmActivityModal.okButton"),
    cancelButton: t("tmbUsedConfirmActivityModal.cancelButton"),
  };
}

export function tmbUsedActivityErrorLiterals(t: any) {
  return {
    title: t("tmbUsedActivityErrorLiterals.title"),
    desc: t("tmbUsedActivityErrorLiterals.desc"),
    okButton: t("tmbUsedActivityErrorLiterals.okButton"),
  };
}

export function tmbUsedActivityLiterals(t: any) {
  return {
    title: t("tmbUsedActivityLiterals.title"),
    desc: t("tmbUsedActivityLiterals.desc"),
    okButton: t("tmbUsedActivityLiterals.okButton"),
    link: t("tmbUsedActivityLiterals.link"),
  };
}

export function tagLiterals(t: any) {
  return {
    travelTag: t("tagLiterals.travelTag"),
    productTag: t("tagLiterals.productTag"),
  };
}

export function daysLiterals(t: any) {
  return {
    diffDayLiterals: t("daysLiterals.diffDayLiterals"),
    diffDaysLiterals: t("daysLiterals.diffDaysLiterals"),
  };
}

export function getCancellationConditionsLiterals(t: any) {
  return {
    title: t("cancellationConditionsLiterals.title"),
    desc1: t("cancellationConditionsLiterals.desc1"),
    desc2: t("cancellationConditionsLiterals.desc2"),
    desc3: t("cancellationConditionsLiterals.desc3"),
    desc1_1: t("cancellationConditionsLiterals.desc1_1"),
    desc1_2: t("cancellationConditionsLiterals.desc1_2"),
    buttons: [
      {
        size: "w100",
        styleButton: "outline",
        idButton: "cancel-button",
        type: "button",
        text: t("cancellationConditionsLiterals.buttons.0.text"),
      },
      {
        size: "w100",
        styleButton: "primary",
        idButton: "continue-button",
        type: "button",
        text: t("cancellationConditionsLiterals.buttons.1.text"),
      },
    ],
  };
}

export function tmbCancelActivity(t: any) {
  return {
    title: t("tmbCancelActivity.title"),
    description: t("tmbCancelActivity.description"),
    text: t("tmbCancelActivity.text"),
    percentage: t("tmbCancelActivity.percentage"),
    cancelButton: t("tmbCancelActivity.cancelButton"),
    back: t("tmbCancelActivity.back"),
  };
}

export function tmbDetail(t: any) {
  return {
    paymentMethod: t("tmbDetail.paymentMethod"),
    summaryPrice: t("tmbDetail.summaryPrice"),
    totalPrice: t("tmbDetail.totalPrice"),
    totalTicket: t("tmbDetail.totalTicket"),
    booking: t("tmbDetail.booking"),
    showCode: t("tmbDetail.showCode"),
    title: t("tmbDetail.title"),
    titleStatusFailed: t("tmbDetail.titleStatusFailed"),
    descriptionStatusFailed: t("tmbDetail.descriptionStatusFailed"),
    discount: t("tmbDetail.discount"),
  };
}

export function sixtDetailVehicle(t: any) {
  return {
    dayPrice: t("sixtDetailVehicle.dayPrice"),
    kmInclude: t("sixtDetailVehicle.kmInclude"),
    automatic: t("sixtDetailVehicle.isAutomatic.automatic"),
    manual: t("sixtDetailVehicle.isAutomatic.manual"),
    isElectric: t("sixtDetailVehicle.isElectric.isElectric"),
    noElectric: t("sixtDetailVehicle.isElectric.noElectric"),
    passengers: t("sixtDetailVehicle.passengers"),
    baggages: t("sixtDetailVehicle.baggages"),
    ageDriver: t("sixtDetailVehicle.ageDriver"),
    totalPrice: t("sixtDetailVehicle.totalPrice"),
  };
}

export function sixtCancelationCorrect(t: any) {
  return {
    title: t("sixtCancelationCorrect.title"),
    desc: t("sixtCancelationCorrect.desc"),
    okButton: t("sixtCancelationCorrect.okButton"),
  };
}
export function sixtCancelationError(t: any) {
  return {
    title: t("sixtCancelationError.title"),
    desc: t("sixtCancelationError.desc"),
    okButton: t("sixtCancelationError.okButton"),
  };
}
export function sixtDetail(t: any) {
  return {
    title: t("sixtDetail.title"),
    bookingTitle: t("sixtDetail.bookingTitle"),
    pickUp: t("sixtDetail.pickUp"),
    return: t("sixtDetail.return"),
    dateReservation: t("sixtDetail.dateReservation"),
    breakdown: t("sixtDetail.breakdown"),
    breakdownDetail: t("sixtDetail.breakdownDetail"),
    vehicle: t("sixtDetail.vehicle"),
    km: t("sixtDetail.km"),
    insurance: t("sixtDetail.insurance"),
    extra: t("sixtDetail.extra"),
    summaryPrice: t("sixtDetail.summaryPrice"),
    totalPrice: t("sixtDetail.totalPrice"),
    include: t("sixtDetail.include"),
    contact: t("sixtDetail.contact"),
    cancelSixt: t("sixtDetail.cancelSixt"),
    sixtUrl: t("sixtDetail.sixtUrl"),
    diffDay: t("sixtDetail.diffDay"),
    diffDays: t("sixtDetail.diffDays"),
    titleStatusFailed: t("sixtDetail.titleStatusFailed"),
    descriptionStatusFailed: t("sixtDetail.descriptionStatusFailed")
  };
};


export function cancelLastTripModal(t: any) {
  return {
    title: t("initialDetailLiterals.cancelLastTripModal.title"),
    description: t("initialDetailLiterals.cancelLastTripModal.description"),
    buttons: [
      {
        text: t("initialDetailLiterals.cancelLastTripModal.buttons.0.text"),
        size: "w100",
        styleButton: "outline",
        idButton: "cancel-button",
        type: "button",
      },
      {
        size: "w100",
        styleButton: "primary",
        idButton: "continue-button",
        type: "button",
        text: t("initialDetailLiterals.cancelLastTripModal.buttons.1.text"),
      },
    ],
  };
}

export function cancelLastTripInfoModal(t: any) {
  return {
    title: t("initialDetailLiterals.cancelLastTripInfoModal.title"),
    description: t("initialDetailLiterals.cancelLastTripInfoModal.description"),
    buttons: [
      {
        text: t("initialDetailLiterals.cancelLastTripInfoModal.buttons.0.text"),
        size: "w100",
        styleButton: "outline",
        idButton: "cancel-button",
        type: "button",
      },
      {
        text: t("initialDetailLiterals.cancelLastTripInfoModal.buttons.1.text"),
        size: "w100",
        styleButton: "primary",
        idButton: "continue-button",
        type: "button",
      },
    ],
  }
}

export function getProvisionCardLiterals(t: any) {
  return {


    title:  t("getProvisionCardLiterals.title"),
    desc: t("getProvisionCardLiterals.desc"),
    aprov: t("getProvisionCardLiterals.aprov"),
    desc2: t("getProvisionCardLiterals.desc2"),
    okButton: t("getProvisionCardLiterals.okButton"),
  };
}


export function initialDriverCommentCanceledLiterals(t: any) {
  return {
    titleComments: t("initialDriverCommentCanceledLiterals.titleComments"),
    descComments: t("initialDriverCommentCanceledLiterals.descComments"),
    infoComments: [
      {
        text: t("initialDriverCommentCanceledLiterals.infoCommentsFirst"),
        bold: false
      },
      {
        text: t("initialDriverCommentCanceledLiterals.infoCommentsSecond"),
        bold: false
      },
      {
        text: t("initialDriverCommentCanceledLiterals.infoCommentsThird"),
        bold: false
      }
    ],
    maintext: t("initialDriverCommentCanceledLiterals.maintext"),
    buttonCancelar: t("initialDriverCommentCanceledLiterals.buttonCancelar"),
    buttonAddComments: t("initialDriverCommentCanceledLiterals.buttonAddComments"),
  };
}

export function initialDriverCommentLiterals(t: any) {
  return {
    titleComments: t("initialDriverCommentLiterals.titleComments"),
    descComments: t("initialDriverCommentLiterals.descComments"),
  };
}


export function DontBuyLiterals(t: any) {
  return {
    titlePage: t("dontBuyLiterals.titlePage"),
    title: t("dontBuyLiterals.title"),
    description: t("dontBuyLiterals.description"),
    leftButton: {
      type: t("dontBuyLiterals.leftButton.type"),
      text: t("dontBuyLiterals.leftButton.text"),
      id: t("dontBuyLiterals.leftButton.id"),
    },
    imageSection: {
      name: t("dontBuyLiterals.imageSection.name"),
      alt: t("dontBuyLiterals.imageSection.alt"),
    },
  };
}